// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://noknqfmmuqptcmpqquad.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5va25xZm1tdXFwdGNtcHFxdWFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcwOTQ1OTUsImV4cCI6MjA3MjY3MDU5NX0.HkW-ayEOQaPdR_fFSvzBlOI5rSaLjZ2yZNHcOLwmjbo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});